// src/pages/Contact.js
import { Instagram, Youtube, Mail } from "lucide-react";
import "../styles/Contact.css";

const Contact = () => {
  return (
    <div className="contact-container">
      <div className="contact-content">
        <h1>Let's Connect</h1>
        <p className="contact-intro">
          Reach out for tech contracts, founder advisory, product engineering
          support, fashion commissions, collaborations, or custom{" "}
          <a
            href="https://www.showbothrows.com"
            target="_blank"
            rel="noopener noreferrer"
            style={{ fontWeight: "bold", textDecoration: "underline" }}
          >
            Both Rows
          </a>{" "}
          pieces? I'd love to hear from you.
        </p>

        <div className="contact-fit-grid">
          <div>
            <h2>For Tech Contracts</h2>
            <p>
              Send the project goal, timeline, current team context, tech stack
              if known, and the decision or delivery problem you need help with.
            </p>
          </div>
          <div>
            <h2>For Fashion Work</h2>
            <p>
              Send the occasion or concept, desired timeline, budget range,
              sizing needs, and any reference images or inspiration.
            </p>
          </div>
        </div>

        <div className="contact-methods">
          <div className="contact-method">
            <Mail size={24} />
            <div className="method-details">
              <h2>Email</h2>
              <a href="mailto:thenerdstar101@gmail.com">
                thenerdstar101@gmail.com
              </a>
            </div>
          </div>

          <div className="contact-method">
            <Instagram size={24} />
            <div className="method-details">
              <h2>Instagram</h2>
              <a
                href="https://instagram.com/nerdstar_101"
                target="_blank"
                rel="noopener noreferrer"
              >
                @nerdstar_101
              </a>
            </div>
          </div>

          <div className="contact-method">
            <Youtube size={24} />
            <div className="method-details">
              <h2>YouTube</h2>
              <a
                href="https://www.youtube.com/channel/UCDcOH62qjN73YkLiYE7LQ6A"
                target="_blank"
                rel="noopener noreferrer"
              >
                @Nerd Wonder
              </a>
            </div>
          </div>
        </div>

        <div className="contact-note">
          <p>
            For business inquiries and collaborations, email is the best way to
            reach me. I typically respond within 1-2 business days.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Contact;
